export { default } from "~/components/blogText/BlogText"

// BlogText with banner + body text — reserve real height to prevent CLS.
export function LoadingFallback() {
  return <div className='w-full min-h-[300px] bg-base-200/30 animate-pulse' />
}
